import client from './axiosConfig';

export const getAllWarehouses = (params) => {
    const config = {
        url: `/inventory/warehouse/`,
        method: "GET",
        params
    }

    const response = client(config);
    return response;
}

export const createWarehouse = (data) => {
    const config = {
        url: `/inventory/warehouse/`,
        method: "POST",
        data
    }

    const response = client(config);
    return response;
}

export const editWarehouseById = (data, id) => {
    const config = {
        url: `/inventory/warehouse/${id}/`,
        method: "PATCH",
        data
    }

    const response = client(config);
    return response;
}

export const deleteWarehouseById = (id) => {
    const config = {
        url: `/inventory/warehouse/${id}/`,
        method: "DELETE",
    }

    const response = client(config);
    return response;
};

export const getStocks = (params) => {
    const config = {
        url: `/inventory/stock/`,
        method: "GET",
        params
    }
    const response = client(config);
    return response;
}

export const createStock = (data) => {
    const config = {
        url: `/inventory/stock/`,
        method: "POST",
        data
    }
    const response = client(config);
    return response;
}

export const editStockById = (data, id) => {
    const config = {
        url: `/inventory/stock/${id}/`,
        method: "PATCH",
        data
    }
    const response = client(config);
    return response;
}

export const deleteStockById = (id) => {
    const config = {
        url: `/inventory/stock/${id}/`,
        method: "DELETE",
    }
    const response = client(config);
    return response;
}

export const getDispatchNote = (params) => {
    const config = {
        url: `/inventory/dispatch-notes/`,
        method: "GET",
        params
    }
    const response = client(config);
    return response;
};

export const getDispatchNotesById = (id) => {
    const config = {
        url: `/inventory/dispatch-notes/${id}/`,
        method: "GET",
    }
    const response = client(config);
    return response;
};

export const getMRRs = (params) => {
    const config = {
        url: `/inventory/mrr/`,
        method: "GET",
        params
    }
    const response = client(config);
    return response;
}   

export const addMRR = (data) => {
    const config = {
        url: `/inventory/mrr/`,
        method: "POST",
        data
    }
    const response = client(config);
    return response;
}

export const getMRRById = (id) => {
    const config = {
        url: `/inventory/mrr/${id}/`,
        method: "GET",
    }
    const response = client(config);
    return response;
}

export const deleteMRRById = (id) => {
    const config = {
        url: `/inventory/mrr/${id}/`,
        method: "DELETE",
    };
    const response = client(config);
    return response;
};

export const updateMRRById = (id, data) => {
    const config ={
        url: `/inventory/mrr/${id}/`,
        method:"PATCH",
        data
    }
    const response = client(config);
    return response;
}

export const createDispatchNotes = (data) => {
    const config = {
        url: `/inventory/dispatch-notes/`,
        method: "POST",
        data
    }
    const response = client(config);
    return response;
};

export const patchDispatchNote = (dn_id, data) => {
    const config = {
        url: `/inventory/dispatch-notes/${dn_id}/`,
        method: "PATCH",
        data
    }
    const response = client(config);
    return response;
};

export const deleteDispatchNote = (dn_id) => {
    const config = {
        url: `/inventory/dispatch-notes/${dn_id}/`,
        method: "DELETE",
    }
    const response = client(config);
    return response;
};

export const getGRNsByMRR = (mrr_id) => {
    const config = {
        url: `/inventory/GoodReceiveNote/mrr-grn-comparison/${mrr_id}/`,
        method: "GET",
    };
    const response = client(config);
    return response;
}

export const getDNsByMRR = (mrr_id) => {
    const config = {
        url: `/inventory/mrr/mrr-dn-comparison/${mrr_id}/`,
        method: "GET",
    };
    const response = client(config);
    return response;
}

export const getProductsByWarehouse = (warehouseId) => {
    const config = {
        url: `/inventory/stock/warehouse/${warehouseId}/products/`,
        method: "GET",
    };
    const response = client(config);
    return response;
};

export const getSTL = (params) => {
    const config = {
        url: `/inventory/stock-transaction-ledger/`,
        method: "GET",
        params
    }
    const response = client(config);
    return response;
}